import type { createBrowserRouter } from 'react-router';

type AppRouter = ReturnType<typeof createBrowserRouter>;

let router: AppRouter | undefined;

export const bindRouter = (instance: AppRouter) => {
  router = instance;
};

/**
 * 全局导航（对应 umi 的 history）
 * 组件内部推荐用 react-router 的 useNavigate，这里给非组件代码（拦截器等）留出口
 */
export const history = {
  push: (to: string) => router?.navigate(to),
  replace: (to: string) => router?.navigate(to, { replace: true }),
  get location() {
    return router?.state.location ?? window.location;
  },
};
